"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCardNumberAmex = formatCardNumberAmex;
exports.formatCardNumberDefault = formatCardNumberDefault;
function formatCardNumberAmex() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var previousValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var onlyNums = value.replace(/[^0-9]/g, '');
  if (!onlyNums) {
    return onlyNums;
  }
  if (previousValue.length <= value.length || Math.abs(previousValue.length - value.length) > 1) {
    if (onlyNums.length < 10) {
      return onlyNums.replace(/(.{4})/, '$1 ').trim();
    }
    if (onlyNums.length >= 10) {
      return onlyNums.replace(/(.{4})(.{6})/, '$1 $2 ').trim();
    }
  }

  // nums and spaces
  return value.replace(/[^\s0-9]/g, '');
}
function formatCardNumberDefault() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var previousValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var onlyNums = value.replace(/[^0-9]/g, '');
  if (!onlyNums) {
    return onlyNums;
  }
  if (previousValue.length <= value.length || Math.abs(previousValue.length - value.length) > 1) {
    return onlyNums.replace(/(.{4})/g, '$1 ').trim();
  }

  // nums and spaces
  return value.replace(/[^\s0-9]/g, '');
}